<div class="col full-height layout-column">

  <app-visit-plan-routes-panel-list-item [route]="route"
                                         [settings]="settings"
                                         [canClose]="true"
                                         [itemElementSize]="itemElementSize"
                                         [isShowActionMenu]="false"
                                         [agentColorMap]="agentColorMap"
                                         (onToggleVisible)="onToggleVisibleRoute(route.id, $event)"
                                         (onLockRouteChange)="onLockRouteChange.emit($event)"
                                         (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                         (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                         (onClose)="onClose()">

  </app-visit-plan-routes-panel-list-item>

  <div class="flex layout-column dndList overflow-auto margin-top-5"
       cdkDropList
       [cdkDropListData]="route.activities"
       id="{{panel.id}}"
       [cdkDropListConnectedTo]="connectedPanelIds"
       [cdkDropListDisabled]="isRouteEditingBlocked"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">

    <div class="layout-column gap-10" *ngFor="let activity of route.activities;let index = index">

      <app-visit-plan-route-tasks-panel-list-item
        class="flex"
        [activity]="activity"
        [jobs]="jobs"
        [activityDetailsMap]="activityDetailsMap"
        [details]="activityDetailsMap[activity.id]"
        [index]="index"
        [route]="route"
        [isRunning]="isRunning"
        [agentColorMap]="agentColorMap"
        [highlightedActivity]="highlightedActivity"
        [itemElementSize]="itemElementSize"
        [isSmallScreen]="isSmallScreen"
        [selectedJobIds]="selectedJobIds"
        [isSelected]="selectedKeys[activity.id]"
        [queryText]="queryText"
        [callServiceTimeMap]="callServiceTimeMap"
        [isDayDispatched]="isDayDispatched"
        (onEditServiceTime)="onEditServiceTime($event.callId, $event.event)"
        (onViewJob)="onViewJob.emit($event)"
        (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
        (onToggle)="onSelectedChange($event.item, $event.isSelected)"
        cdkDrag
        [cdkDragDisabled]="(activity.type === 'START' || activity.type === 'END') || isRouteEditingBlocked"
        [cdkDragData]="activity">

        <div cdkDragHandle
             [ngbTooltip]="blockedActionTooltipKey | translate"
             container="body"
             openDelay="300">
          <bringoz-icon iconName="drag" class="secondary-100"
                        [ngClass]="{disabled: isRouteEditingBlocked}"></bringoz-icon>
        </div>

        <div *ngIf="isMultipleActivitiesDragged(activity.jobIds || [activity.jobId])">
          <div *cdkDragPreview id="app-visit-plan-route-tasks-panel-list-preview-drag-multiple-activities-container">
            {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedJobIds.length} }}
          </div>
        </div>

      </app-visit-plan-route-tasks-panel-list-item>
    </div>

    <ng-template cdkDropListPlaceholder>
      <div class="placeholder">Drop here</div>
    </ng-template>

  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading || isRunning"></app-bringoz-linear-progress>


</div>

